import React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { motion, useReducedMotion } from 'motion/react';

export function TooltipProvider({ children, delayDuration = 400 }: any) {
  return (
    <TooltipPrimitive.Provider delayDuration={delayDuration}>{children}</TooltipPrimitive.Provider>
  );
}

export function Tooltip({ content, children, side = 'top', align = 'center' }: any) {
  const reduceMotion = useReducedMotion();

  if (!content) return children;

  const yOffset = side === 'top' ? 4 : side === 'bottom' ? -4 : 0;

  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content side={side} align={align} sideOffset={6} asChild>
          <motion.div
            initial={reduceMotion ? false : { opacity: 0, scale: 0.92, y: yOffset }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={
              reduceMotion ? { duration: 0 } : { type: 'spring', stiffness: 400, damping: 30 }
            }
            className="z-[100] max-w-xs rounded-md bg-gray-900 px-2.5 py-1.5 text-center text-xs font-medium text-white shadow-md"
          >
            {content}
            <TooltipPrimitive.Arrow className="fill-dark-elevated" />
          </motion.div>
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}

export default Tooltip;
